import React from 'react'
import PropTypes from 'prop-types'
import { Cell, Grid } from '@fs/zion-ui'
/**
 * Displays the page title, search column, and back to records home button.
 * @param {string} filter - The string to filter for when using the search function
 * @param {Function} onFilterChange - Function that triggers the table to re-render on new search input
 * @param {string} title - Title of the dashboard
 * @param {string} translationKeyPrefix - Key prefix for translations
 */
function DashboardHeader({ children, gridColumns }) {
  if (
    (Array.isArray(children) && children.length !== gridColumns.length) ||
    (!Array.isArray(children) && gridColumns.length > 1)
  ) {
    throw new Error("Prop 'gridColumns' must be same length as number of children")
  }
  return (
    <Grid guttersY="none">
      {Array.isArray(children) ? (
        children.map((child, index) => {
          return (
            // eslint-disable-next-line react/no-array-index-key
            <Cell key={`header-child-${index}`} columns={gridColumns[index]}>
              {child}
            </Cell>
          )
        })
      ) : (
        <Cell columns={gridColumns[0]}>{children}</Cell>
      )}
    </Grid>
  )
}

DashboardHeader.propTypes = {
  children: PropTypes.node,
  gridColumns: PropTypes.arrayOf(PropTypes.number),
}

export default React.memo(DashboardHeader)
